import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import GalleryPage from "./pages/GalleryPage";
import ThankYou from "./pages/ThankYou";
import "./i18n"; // Initialize i18n

// Component to handle scroll to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);

    return null;
}

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Header />
            <div className="pt-20">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:productId" element={<ProductDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/gallery" element={<GalleryPage />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                </Routes>
            </div>
            <Footer />
        </Router>
    );
}

export default App;
